import TextButton from 'components/textButton'
import { URL_MEMBRESIAS } from 'config'
import RoundedIcon from 'components/RoundedIcon'
import { FireMembership } from 'assets/icons'
import WORDING from 'constants/wording'
import React from 'react'

const { WAYNI_PLUS, KNOW_MORE } = WORDING

const MembershipLegend = () => (
  <div className='w-full my-9 rounded-lg md:flex md:flex-col md:justify-center md:items-center'>
    <div className='h-12 px-3 gap-2 bg-green-800 text-xs font-bold leading-4 text-white shadow-cardBanner rounded-lg flex flex-row items-center md:w-[360px]'>
      <RoundedIcon
        icon={<FireMembership className='w-4 h-4' />}
        className='w-7 h-7'
      />
      {WAYNI_PLUS}
    </div>
    <TextButton
      className='mt-3 text-xs'
      handleFunction={() => window.open(URL_MEMBRESIAS, '_blank')}
    >
      {KNOW_MORE}
    </TextButton>
  </div>
)

export default MembershipLegend
